import React from "react";

import { Grid, MenuItem, Select } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import { THEME } from "../../../utils/constants.js";
import { setTheme } from "../../../redux-saga/redux/settings/index.js";
import useStyles from "./theme.styles.js";

function ThemeSelect() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const seletedTheme = useSelector((state) => state.settings.theme);
  const handleThemeChange = (event) => dispatch(setTheme(event.target.value));
  return (
    <Select
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      value={seletedTheme}
      label="Age"
      onChange={handleThemeChange}
      className={classes?.select}
      MenuProps={{
        PaperProps: {
          className: classes.popper
        }
      }}
    >
      <MenuItem
        value={THEME?.DARK_BLUE_YELLOW_THEME}
        className={classes?.menuItem}
      >
        <Grid className={classes?.themeCircle}>
          <Grid className="yellow"></Grid>
          <Grid className="darkblue"></Grid>
        </Grid>
      </MenuItem>
      <hr />
      <MenuItem value={THEME.RED_GREEN_THEME} className={classes?.menuItem}>
        <Grid className={classes?.themeCircle}>
          <Grid className="red"></Grid>
          <Grid className="green"></Grid>
        </Grid>
      </MenuItem>
    </Select>
  );
}

export default ThemeSelect;
